import { AxiosRequestConfig } from 'axios';
import { merge } from 'lodash';

import { generateAuthHeaders } from '@src/factories';

import Client from './client';

type Data = {
  bio?: string;
  coverPhoto?: string;
  gender: string;
  link?: string;
  name: string;
  profilePicture?: string;
  username: string;
  validGender: boolean;
};

type Response = {
  readonly result: 'SUCCESS' | 'ERROR';
  readonly status: number;
};

export default (
  accessToken: string,
  data: Data,
  config?: AxiosRequestConfig
) => {
  return Client.put<Response>(
    '/um/v1/profiles',
    data,
    merge(config, generateAuthHeaders(accessToken))
  );
};
